export default "__VITE_PUBLIC_ASSET__4cb14ef8__"